<template>
  <div class="d-inline mt-2 text-primary" @click="resetAll()">
    <a href="javascript:void(0);">Reset all</a>
  </div>
</template>

<script>
export default {
  name: 'ResetAllText',

  methods: {
    resetAll() {
      /**
       * remove all search result
       *
       * @event reset
       */
      this.$emit('reset');
    }
  }
};
</script>

<style lang="scss" scoped></style>
